<template>
    <div class="addPage">
        <el-form  :model="formData" :rules="formRules" ref="formRef" label-width="100px" size="mini">
<!--            <el-row>{{formData.title}}</el-row>-->
<!--            <el-form-item class="form-title" prop="city" label="城市" >-->

<!--            </el-form-item>-->
            <!--<div style="width: 100%;margin-bottom: 10px" class="flex" align="left">
                    <el-input  style="width: 15% ;margin-left: 20px" v-model="dzName" placeholder="请输入目的地" clearable size="mini"></el-input>
            </div>-->
            <el-col :span="6">
                <el-select v-model="formData.city" multiple filterable placeholder="请选择添加城市" size="mini" @change="dataList" @visible-change="getCity"  filterable required clearable>
                    <el-option
                            v-for="one in cityList"
                            :key="one.i_id"
                            :label="one.vc_name"
                            :value="one.i_id">
                        <!--                                <span  style="display: inline-block;width: 100%">{{one.vc_name}}</span>-->
                    </el-option>
                </el-select>
                    <el-tree
                            :style="`height:${tableHeight-28}px;overflow-y: auto;`"
                            node-key="value"
                            ref="tree"
                            :data="addressList"
                            :props="defaultProps"
                            :highlight-current="true"
                            accordion
                            lazy
                            :load="loadNode"
                            show-checkbox
                            :default-checked-keys="has"
                            :default-expanded-keys="expanded"
                            :expand-on-click-node="false"
                            :filter-node-method="filterNode"
                            @node-click="handleNodeClick">
                        <span class="custom-tree-node" slot-scope="{ node, data }">
                            <span>{{ node.label }}</span>
                            <span >
                              <!--<el-button
                                      type="text"
                                      size="mini"
                                      @click="() => appendData(data,node)">
                               下一级
                              </el-button>-->
                                <el-button
                                        class="delete"
                                        v-if="data.i_isInput==1"
                                      type="text"
                                      size="mini"
                                      @click="() => deleteBtn(data,node)">
                               <i class="el-icon-delete"></i>
                              </el-button>
                            </span>
                        </span>
                    </el-tree>
            </el-col>
            <el-col :span="18">
                <el-row>{{formData.lab}}</el-row>
                <template>
                    <el-table
                            ref="table"
                            size="mini"
                            :height="tableHeight"
                            border
                            :key="tableId"
                            :row-class-name="tableRowClassName"
                            :data="tableData"
                            style="width: 100%">
                        <!--<template slot="empty">
                            <p>{{dataText}}</p>
                        </template>-->
                        <!--<el-table-column width="35px" align="center">
                            <template slot="header" slot-scope="scope">
                                <el-button class="addbtn" @click="addNew" slot="reference" :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>
                            </template>
                            <template  slot-scope="scope">
                                <div class="iconminus">
                                    <span class="minus" @click="delTraderResource(scope.row,scope.$index)"><i class="el-icon-minus"></i></span>
                                </div>
                            </template>
                        </el-table-column>-->
                       <!-- <el-table-column align="center" label="目的地" min-width="180" prop="value" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <el-form-item class="tableForm-item mdd" :prop="'tableData.'+scope.$index+'.value'" :rules="formRules.value">
                                    <el-cascader
                                            ref="cas"
                                            separator=""
                                            clearable
                                            filterable
                                            placeholder="请选择目的地"
                                            class="changeinput"
                                            v-model="scope.row.value"
                                            :options="addressList"
                                            @change="handleChange(scope.row)"
                                            :disabled="scope.row.i_state==-1"></el-cascader>
                                </el-form-item>
                            </template>
                        </el-table-column>-->
                        <el-table-column align="center" label="最小重量" width="100" prop="f_minWeight"></el-table-column>
                        <el-table-column align="center" label="最大重量" width="100" prop="f_maxWeight"></el-table-column>
                        <el-table-column align="center" label="单位" prop="unit">吨</el-table-column>
                        <el-table-column align="center" label="普货价格"  prop="f_phprice">
                            <template slot-scope="scope">
                                <el-form-item class="tableForm-item" :prop="'tableData.'+scope.$index+'.f_phprice'" :rules="formRules.f_phprice">
                                    <el-input  class="changeinput" v-model="scope.row.f_phprice"  size="mini" :disabled="scope.row.i_state==-1" @change="phpriceCtrl(scope.row,scope.$index)"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="危货价格"  prop="f_whprice">
                            <template slot-scope="scope">
                                <el-form-item class="tableForm-item" :prop="'tableData.'+scope.$index+'.f_whprice'" :rules="formRules.f_whprice">
                                    <el-input  class="changeinput" v-model="scope.row.f_whprice" size="mini" :disabled="scope.row.i_state==-1" @change="whpriceCtrl(scope.row,scope.$index)"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="普货送货费"  prop="f_phshprice" width="90">
                            <template slot-scope="scope">
                                <el-form-item class="tableForm-item" :prop="'tableData.'+scope.$index+'.f_phshprice'" :rules="formRules.f_phshprice">
                                    <el-input  class="changeinput" v-model="scope.row.f_phshprice"  size="mini" :disabled="scope.row.i_state==-1" @change="phpriceCtrl(scope.row,scope.$index)"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="危货送货费"  prop="f_whshprice" width="90">
                            <template slot-scope="scope">
                                <el-form-item class="tableForm-item" :prop="'tableData.'+scope.$index+'.f_whshprice'" :rules="formRules.f_whshprice">
                                    <el-input  class="changeinput" v-model="scope.row.f_whshprice" size="mini" :disabled="scope.row.i_state==-1" @change="whpriceCtrl(scope.row,scope.$index)"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="普货最低运费"  prop="f_minPhPrice" width="100">
                            <template slot-scope="scope">
                                <el-form-item class="tableForm-item" :prop="'tableData.'+scope.$index+'.f_minPhPrice'" :rules="formRules.f_minPhPrice">
                                    <el-input  class="changeinput" v-model="scope.row.f_minPhPrice"  size="mini" :disabled="scope.row.i_state==-1" @change="phpriceCtrl(scope.row,scope.$index)"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="危货最低运费"  prop="f_minWhPrice" width="100">
                            <template slot-scope="scope">
                                <el-form-item class="tableForm-item" :prop="'tableData.'+scope.$index+'.f_minWhPrice'" :rules="formRules.f_minWhPrice">
                                    <el-input  class="changeinput" v-model="scope.row.f_minWhPrice" size="mini" :disabled="scope.row.i_state==-1" @change="whpriceCtrl(scope.row,scope.$index)"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="到货天数"  prop="f_dhdays">
                            <template slot-scope="scope">
                                <el-form-item class="tableForm-item" :prop="'tableData.'+scope.$index+'.f_dhdays'" :rules="formRules.f_dhdays">
                                    <el-input  class="changeinput" v-model="scope.row.f_dhdays" size="mini" :disabled="scope.row.i_state==-1" @change="whpriceCtrl(scope.row,scope.$index)"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </el-col>
        </el-form>
        <div class="pz" style="text-align: center">
            <el-button class="bcBtn" @click="saveBtn" :class="baseerp+'btn'" size="mini" :disabled="isSaved">
                保存
            </el-button>
            <el-button @click="cancel" size="mini">{{$t('button_cancel')}}</el-button>
        </div>
    </div>

</template>

<script>
    import * as API from  "./../api";
    import {baseerp} from "@/utils/baseUrl";
    import {mapActions} from "vuex";
    import login from "../../login/login";
    export default {
        name: 'ChangePlace',
        props:{
            bjSP:{
              type: Object,
              required:true,
          }
        },
        data(){
            //只能输入数字
            var validateNum= (rule, value, callback) =>{
                // console.log(typeof value*1,"typeof",value*1)
                if (!Number.isFinite(value*1)) {
                    callback(new Error('请输入数字值'));
                }else {
                    // callback((value*1).toFixed(2));
                }
                // value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '');
            };
            return{
                ilist:[],
                sizepag:"",
                iistate:"",
                pageSize:1,
                pageCount:20,
                total:0,
                currentPage:1,
                formRef:{},
                currencyList:[
                    {i_bzid:1,vc_bzname:"元"},
                    {i_bzid:2,vc_bzname:"美元"},
                    {i_bzid:3,vc_bzname:"欧元"},
                    {i_bzid:10268,vc_bzname:"越南盾"}
                ],
                formData:{
                    title:"",
                    dzName:"",
                    city:[],
                    tableData: [],
                    lab: '',
                },
                formRules:{
                    f_phprice:[{required:true,message:"请输入普货价格",trigger:"change"},
                        { validator: validateNum, trigger: 'blur' }],
                    f_whprice:[{required:true,message:"请输入危货价格",trigger:"change"},
                        { validator: validateNum, trigger: 'blur' }],
                    f_phshprice:[{required:true,message:"请输入普货送货费",trigger:"change"},
                        { validator: validateNum, trigger: 'blur' }],
                    f_whshprice:[{required:true,message:"请输入危货送货费",trigger:"change"},
                        { validator: validateNum, trigger: 'blur' }],
                    f_minPhPrice:[{required:true,message:"请输入普货最低运费",trigger:"change"},
                        { validator: validateNum, trigger: 'blur' }],
                    f_minWhPrice:[{required:true,message:"请输入危货最低运费",trigger:"change"},
                        { validator: validateNum, trigger: 'blur' }],
                    f_dhdays:[{required:true,message:"请输入到货天数",trigger:"change"},
                        { validator: validateNum, trigger: 'blur' }],
                },
                tableData: [],
                bftableData: [],
                isSaved:false,
                baseerp:'',
                tableHeight:0,
                // dataText:"数据加载中...",
                tableId:"",
                dzName:"",
                addressList:[],
                cityList:[],
                // vc_endPlace:[],
                value:[],
                isbtn:false,
                delList:[],
                updateList:[],
                i_pid:0,
                defaultProps: {
                    children: 'children',
                    label: 'label',
                    isLeaf: 'isLeaf'
                },
                parentList:[],
                labelList:[],
                cityData:[],
                has:[],
                expanded:[],
                lastData:"",
                nodeData:"",
                // i_addressPid:0,
            }
        },
        watch: {
            dzName(val) {
                this.$refs.tree.filter(val);
            }
        },
        mounted() {

            //console.log(this.bjSP,"this.bjSP");
            this.i_pid=this.bjSP.value.i_id;
            this.sizepag=this.bjSP.currentPage;
            this.iistate=this.bjSP.state;
            /*this.addressList=[{
                        value: '320100',
                        label: '南京',
                        children: [{
                            value: '320105',
                            label: '建邺区',
                            /!*children: [{
                                value: '320105400',
                                label: '新城科技园'
                            }]*!/
                        }]
                    },{
                        value: '279',
                        label: '无锡市',
                        children: [{
                            value: '533',
                            label: '锡山区'
                        },{
                            value: '1327',
                            label: '江阴市'
                        }]
                    }];*/
            //console.log("addressList111",this.addressList);
            this.setDisabled(this.addressList);
            this.getCityList();

            this.baseerp=baseerp;
            // this.formData.title=this.bjSP.vc_region;
            // this.getAddress();
            this.$nextTick(function () {
                window.addEventListener('resize',this.heightAuto);
                this.heightAuto();
            });
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            heightAuto(){
                this.tableHeight = window.innerHeight - this.$refs.table.$el.clientTop - 330;
            },
            loadNode(node, resolve) {
                //console.log("load","node",node,"resolve",resolve);
                let _this=this;
                if (node.level === 0) {
                    let val={
                        value:0,
                        i_level:1,
                    }
                    setTimeout(() => {
                        _this.getAddressTree(val,resolve);
                    }, 100)
                }
                if (node.level>=1&&node.data.isLeaf==false){
                    _this.expanded=[];
                    _this.getAddressTree(node.data,resolve);
                    _this.expanded.push(node.data.value)
                }
            },
            handleNodeClick(data,node,e) {
                //console.log("handleNodeClick",data,node)
                let copeData=this.nodeData;
                //console.log(copeData,"copeData");
                // this.isSaved=false;
                // console.log(copeData,"copeData",node)
                if (this.lastData!=data.value){
                    //console.log(this.isSaved,"save");
                    if (this.isSaved==false){
                        this.beforeSave();
                    }else {
                        this.isSaved=false;
                    }
                    this.parentList = [];
                    this.labelList = [];
                    this.tableData=[];
                    this.getTreeNode(node);
                    if (this.addList.length!=0||this.updateList.length!=0){
                        this.$confirm('是否保存已更改的运费?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then( () => {
                            //console.log("copeData",copeData);
                            this.saveBtn(copeData,1);
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消保存'
                            });
                        });
                    }

                    if (data.i_childIsInput==0&&node.parent.data.i_isInput==0){
                        this.getFreightDetail(this.parentList);
                    }
                    this.lastData=data.value;
                    //console.log("this.lastData",this.lastData);
                }
                this.formData.lab=this.labelList.join("-");
                this.nodeData=node;
                //console.log(this.nodeData,"nodedata");
            },
            getTreeNode(node) {
                //console.log("node",node);
                if (node) {
                    if (node.parent ??''!=='') {
                      this.parentList.unshift(node.data.value);
                      this.labelList.unshift(node.data.label);
                        this.getTreeNode(node.parent);
                    }
                }
                //console.log("parent",this.parentList);
                //console.log("label",this.labelList);
            },
            filterNode(value, data) {
                //console.log("filter","value",value,"data",data);
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },
            async getCityList(){
                let params={
                    i_pid:this.i_pid,
                };
                let res=await API.getCityList(params);
                if(res.code==1){
                    this.cityList=res.list.filter(one=>one.i_isInput==0&&one.i_childIsInput==0);
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getAddressTree(val,resolve){
                let params={
                    i_pid:this.i_pid,
                    i_addressPid:val.value,
                    i_level:val.i_level+1,
                };
                let res=await API.getAddressTree(params);
                if(res.code==1){
                    let list=[];
                    if (res.list.length>0){
                        res.list.map(one=>{
                            let isLeaf=true;
                            if (one.i_hasChild==1){isLeaf=false;}
                            let hash={
                                label:one.vc_name,
                                value:one.i_addressPid,
                                i_hasChild:one.i_hasChild,
                                i_level:one.i_level,
                                i_isInput:one.i_isInput,
                                i_childIsInput:one.i_childIsInput,
                                isLeaf: isLeaf,
                            };
                            // console.log(hash,"hash")
                            list.push(hash);
                            //console.log("list",list);
                            /*if (node.level==0){
                                this.$refs.tree.append(hash,this.nodeData.data);
                            }else {
                                this.$refs.tree.append(hash,node.data);
                            }*/
                            //console.log(this.has,"this.has");
                            this.$refs.tree.setCheckedKeys(this.has);
                        })
                    }
                    this.setDisabled(list);
                    return resolve(list);
                    //console.log(this.addressList,"this.addressList")
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }

            },
            focus(){
                this.formData.city=[];
            },
            dataList(data) {
                //console.log("data",data);
                this.cityData = data;
                //console.log("cityData",this.cityData);
            },
            getCity(data){
                //console.log(data,"getcity");
                if (!data){
                    //console.log(data,"getcity");
                    let arr=[];
                    if (this.cityData.length>0){
                        this.cityData.map(one=>{
                            //console.log("one1",one);
                            let obj=this.cityList.find(two=>two.i_id==one);
                            //console.log("one2",one);
                            //console.log("obj",obj);
                            let info={
                                value:one,
                                label:obj.vc_name,
                                i_hasChild:obj.i_hasChild,
                                i_level:obj.i_level,
                                i_isInput:obj.i_isInput,
                                i_childIsInput:obj.i_childIsInput,
                                isLeaf:false,
                            };
                            arr.push(info);
                            this.$refs.tree.append(info);
                            this.cityList.splice(this.cityList.findIndex(item => item.i_id === info.value), 1);
                        });

                        /*this.addressList=[...this.addressList,...arr];
                        let hash = {};
                        this.addressList = this.addressList.reduce(function(item, next) {
                            hash[next.value] ? '' : hash[next.value] = true && item.push(next);
                            return item
                        }, []);*/
                        this.setDisabled(arr)
                        // console.log(arr,"arr")
                        // this.setDisabled(this.addressList);
                        this.expanded=[];
                    }

                }else {
                    this.formData.city=[];
                    this.cityData=[];
                };
            },
            appendData(data,node){
                // console.log(data,"dada",node);
                if (data.i_isInput==1){
                    this.$confirm('确定删除已保存的运费,去下一级?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then( () => {
                        this.deleteData(data,1);
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
                }else if(data.i_isInput==0){
                    this.expanded=[];
                    this.getAddressTree(data);
                    this.expanded.push(data.value)
                    // console.log(this.expanded,"expanded")
                }
            },
            deleteBtn(data,node){
                this.$confirm('确定删除已保存的运费?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then( () => {
                    this.deleteData(node,1);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            async deleteData(node,i_type){
                // console.log(this.has,"befordelelte")
                let params={
                    i_pid:this.i_pid,
                    i_addressPid:node.data.value,
                    i_level:node.data.i_level,
                    i_type:i_type,
                };
                let res=await API.voidFreightInfo(params);
                if(res.code==1){
                    this.expanded=[];
                    /*if (i_type!=2){
                        this.getAddressTree(data);
                        this.expanded.push(data.value);
                        this.tableData=[];
                    }*/
                    let l=this.parentList.length;
                    if (l==1){
                        if (i_type==2){
                            this.addressList.find(one=>one.value==this.parentList[0]).i_childIsInput=0;
                            (this.addressList.find(one=>one.value==this.parentList[0])).children.map(two=>{
                                if(two.i_isInput==1){two.i_isInput=0;this.has.splice(this.has.findIndex(item => item === two.value),1);}
                                if(two.i_childIsInput==1){
                                    two.i_childIsInput=0;
                                    two.children.map(three=>{
                                        if(three.i_isInput==1){
                                            three.i_isInput=0;
                                            this.has.splice(this.has.findIndex(item => item === three.value),1)
                                        }
                                    })
                                }
                            });
                        }else {
                            // this.addressList.find(one=>one.value==this.parentList[0]).i_isInput=0;
                            node.data.i_isInput=0;
                        }
                    }else if (l==2){
                        node.data.i_isInput=0;
                        if (i_type==2){
                            this.addressList.find(one=>one.value==this.parentList[0]).i_childIsInput=0;
                            (this.addressList.find(one=>one.value==this.parentList[0]).children.find(two=>two.value==this.parentList[1])).i_childIsInput=0;
                            ((this.addressList.find(one=>one.value==this.parentList[0])).children.find(two=>two.value==this.parentList[1])).children.map(three=>{
                                if(three.i_isInput==1){
                                    three.i_isInput=0;
                                    this.has.splice(this.has.findIndex(item => item === three.value),1)
                                }
                            });
                        }else {
                            if (node.parent.childNodes.find(one=>one.data.i_isInput==1)==undefined){
                                node.parent.data.i_childIsInput=0;
                            }

                        }
                    }else if (l==3){
                        if (i_type!=2){
                            node.data.i_isInput=0;
                            /*this.addressList.find(one=>one.value==this.parentList[0]).i_childIsInput=0;
                            (this.addressList.find(one=>one.value==this.parentList[0])).children.find(two=>two.value==this.parentList[1]).i_childIsInput=0;
                            ((this.addressList.find(one=>one.value==this.parentList[0])).children.find(two=>two.value==this.parentList[1])).children.find(three=>three.value==this.parentList[2]).i_isInput=0;*/
                            console.log(node.parent.childNodes.find(one=>one.data.i_isInput==1),"dele")
                            if (node.parent.childNodes.find(one=>one.data.i_isInput==1)==undefined){

                                node.parent.data.i_childIsInput=0;
                            }
                           if (node.parent.parent.childNodes.find(one=>one.data.i_isInput==1||one.data.i_childIsInput==1)==undefined){
                                node.parent.data.i_childIsInput=0;
                            }
                            // console.log(node.parent.parent.childNodes.find(one=>one.data.i_isInput==1),"find")

                        }
                    }
                    if (i_type!=2) {
                        this.has.splice(this.has.findIndex(item => item === node.data.value), 1);
                        this.tableData=[];
                    }
                    this.has=[...new Set(this.has)];
                    this.$nextTick(function () {
                        this.$refs.tree.setCheckedKeys(this.has,true);
                        // console.log(this.has,"delete")
                    });

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getFreightDetail(data){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params={
                   /* i_countryId:data[0],
                    i_provinceId:data[1],*/
                    i_cityId:data[0],
                    i_areaId:data[1]||0,
                    i_streetId:data[2]||0,
                    i_pid:this.i_pid,
                };
                let res=await API.getFreightDetail(params);
                if(res.code==1){
                    this.tableData=res.list;
                    this.bftableData=JSON.parse(JSON.stringify(res.list));
                    this.formData.tableData=res.list;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            //录入控制
            whpriceCtrl(val,index){
                // console.log(val,"val")
                this.tableData[0].f_whprice=Math.round((parseFloat(this.tableData[0].f_whprice))*100)/100;
                this.tableId=Math.random();
            },
            phpriceCtrl(val,index){
                this.tableData[0].f_phprice=Math.round((parseFloat(this.tableData[0].f_phprice))*100)/100;
                this.tableId=Math.random();
            },
            tableRowClassName({row,index}){
                // console.log(row.f_fd_price,"row.f_fd_price")
                // this.price=row.f_price;
                // if (this.tableData[index].f_last_price??''!==""){
                   /* if (row.i_state==-1){
                        return 'border_waring';
                    // }
                }*/
            },
            pageCurrentChange(val){
                // console.log(val,"val")
                this.tableData=[];
                this.pageSize=val;
                this.currentPage=val;
                this.getPzMessage();
            },
            //保存按钮
            beforeSave(){
                //console.log(this.tableData,"tableData");
                let addList=this.tableData.filter(item=>item.i_id==0&&item.f_phprice!=0&&item.f_whprice!=0&&item.f_minPhPrice!=0&&item.f_minWhPrice!=0);
                addList.map(item=>{
                    /* item.i_countryId=this.parentList[0];
                     item.i_provinceId=this.parentList[1];*/
                    item.i_cityId=this.parentList[0];
                    item.i_areaId=this.parentList[1];
                    item.i_streetId=this.parentList[2];
                    item.vc_endPlace=this.labelList.join("");
                    item.i_lruid=sessionStorage.getItem("userid");
                });
                //console.log(addList,"addList");
                let updateList=[];
                this.bftableData.map((one)=>{
                    if (one.i_id!=0){
                        let hash=this.tableData.find((two)=>one.i_id==two.i_id);
                        if (hash){
                            if (one.f_phprice!=hash.f_phprice||one.f_whprice!=hash.f_whprice||one.f_minPhPrice!=hash.f_minPhPrice||one.f_minWhPrice!=hash.f_minWhPrice||one.f_phshprice!=hash.f_phshprice||one.f_whshprice!=hash.f_whshprice||one.f_dhdays!=hash.f_dhdays){
                                updateList.push(hash);
                            }
                        }
                    }
                });
                updateList.map(item=>{
                    /*item.i_countryId=this.parentList[0];
                    item.i_provinceId=this.parentList[1];*/
                    item.i_cityId=this.parentList[0];
                    item.i_areaId=this.parentList[1];
                    item.i_streetId=this.parentList[2];
                    item.vc_endPlace=this.labelList.join("");
                    item.i_lruid=sessionStorage.getItem("userid");
                });
                this.addList=addList;
                this.updateList=updateList;
            },
            saveBtn(data,n){
                // console.log(data)
                this.isSaved=true;
                if (n!=1){
                    this.beforeSave();
                }
                if (this.addList.length>0||this.updateList.length>0){
                    // console.log(this.nodeData.i_childIsInput,"this.nodeData.i_childIsInput")
                    /*if (this.nodeData.i_childIsInput == 1) {
                        this.$confirm('是否删除下级已保存的运费并保存该运费?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.editFreightInfo(null,2);
                            this.deleteData(this.nodeData,2);
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消保存'
                            });
                        });
                    }else {
                        if (n==1){
                            this.editFreightInfo(data,null);
                        }else {
                            this.editFreightInfo(null,null);
                        }

                    }*/
                    if (n==1){
                        this.editFreightInfo(data,null,n);
                        // console.log(data,"data")
                    }else {
                        this.editFreightInfo(this.nodeData,null,null);
                    }
                }else {
                    this.$message.error("请编辑运费");
                    this.isSaved=false;
                }
            },
            async editFreightInfo(data,i_type,n){
                // console.log(data,"aaaaa")
                    let saveParams={
                        addList:this.addList,
                        updateList:this.updateList,
                    };
                    let res=await API.editFreightInfo(saveParams);
                    if(res.code==1){
                        this.$message({
                            message: '保存成功,请到待提交中查看',
                            type: 'success'
                        });
                        let l=this.parentList.length;
                        if (l==1){
                            /*this.addressList.map(one=> {
                                if (one.value == this.parentList[0]) {
                                    one.i_isInput=1;
                                }
                            })*/
                            /*this.addressList.find(one=>one.value==this.parentList[0]).i_isInput=1;*/
                        }else if (l==2){
                            data.parent.data.i_childIsInput=1;
                            /*this.addressList.find(one=>one.value==this.parentList[0]).i_childIsInput=1;
                            (this.addressList.find(one=>one.value==this.parentList[0])).children.find(two=>two.value==this.parentList[1]).i_isInput=1;
                            /!*this.addressList.map(one=> {
                                if (one.value == this.parentList[0]) {
                                    one.i_childIsInput=1;
                                    one.children.map(two=>{
                                        if (two.value == this.parentList[1]) {
                                            two.i_isInput = 1;
                                        }
                                    })
                                }
                            })*!/*/
                        }else if (l==3){
                            data.parent.data.i_childIsInput=1;
                            data.parent.parent.data.i_childIsInput=1;
                            /*this.addressList.find(one=>one.value==this.parentList[0]).i_childIsInput=1;
                            (this.addressList.find(one=>one.value==this.parentList[0])).children.find(two=>two.value==this.parentList[1]).i_childIsInput=1;
                            ((this.addressList.find(one=>one.value==this.parentList[0])).children.find(two=>two.value==this.parentList[1])).children.find(three=>three.value==this.parentList[2]).i_isInput=1;
                            /!*this.addressList.map(one=> {
                                if (one.value == this.parentList[0]) {
                                    one.i_childIsInput=1;
                                    one.children.map(two=>{
                                        if (two.value == this.parentList[1]) {
                                            two.i_childIsInput = 1;
                                            two.children.map(three => {
                                                if (three.value == this.parentList[2]) {
                                                    three.i_isInput = 1;
                                                }
                                            })
                                        }
                                    })
                                }
                            })*!/*/
                        }
                        data.data.i_isInput=1;
                        if (data!=null){
                            this.has.push(data.data.value);
                            // console.log(this.has,"savejas")
                        }else {
                            this.has.push(this.parentList[l-1]);
                            // console.log(this.has,"savejas")
                        }
                        this.has=[...new Set(this.has)];
                        if (n==1){
                            this.isSaved=false;
                        }
                        this.addList=[];
                        this.updateList=[];
                        // this.isSaved=true;
                    }else if (res.code == -2) {
                        this.isSaved=false;
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    }
                    else {
                        this.isSaved=false;
                        this.$message.error(res.message);
                    }

            },
            setDisabled(arr) {
                for (let i = 0; i < arr.length; i++) {
                    arr[i]['disabled'] = true;
                    if (arr[i].i_isInput==1){
                        this.has.push(arr[i].value);
                    }
                    if (arr[i].children && arr[i].children.length > 0) {
                        this.setDisabled(arr[i].children)
                    }
                }
                this.has=[...new Set(this.has)];
                //console.log(this.has,"setDisabled")
            },
            //close关闭弹窗
            cancel(){
                //console.log("sizepag",this.sizepag,"iistate",this.iistate);
                if (this.iistate==3){
                    this.ilist=[0,1]
                    //console.log(this.ilist,"ilist1");
                }else{
                    this.ilist.push(this.iistate);
                    //console.log(this.ilist,"ilist2");
                }
                this.$emit('closebj');
                this.$emit('getAgreementList',this.ilist,this.sizepag);
            },
        },
        beforeDestroy() {
            window.removeEventListener('resize',this.heightAuto)
        },
    }
</script>

<style lang="scss" >
    .addPage{
        .el-icon-plus {
            font-size: 20px;
            color: #3e82e8;
            font-weight: bolder;
        }
        .addbtn {
            border: none;
            padding: 0;
        }
        .border_waring{
            background-color: #9e9e9e;
        }
        .mdd .el-input__inner{
            min-width: 160px;
        }
        .custom-tree-node {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 12px;
            padding-right: 8px;
        }
        .el-select{
            max-height: 54px;
        }
        .el-select__tags{
            max-height: 52px;
            overflow-y: auto;
        }
        .tree{
            height: calc(100vh - 50px);
            overflow-y: auto;
        }
        .delete{
            display: none;
        }
        .custom-tree-node:hover .delete{
            display: block;
        }
        .el-tree-node__loading-icon {
            display: none;
        }
    }

</style>